// frontend/src/context/AuthContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { api, setUserRole } from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
  const savedUser = localStorage.getItem("user");
  return savedUser ? JSON.parse(savedUser) : null;
});
  const [error, setError] = useState(null);

  useEffect(() => {
  const savedUser = localStorage.getItem("user");
  const savedRole = localStorage.getItem("userRole");

  if (savedUser && savedRole) {
    setUser(JSON.parse(savedUser));
    setUserRole(savedRole); // 🔥 VERY IMPORTANT
  }
}, []);


  const login = async (username, password) => {
    try {
      const data = await api.login(username, password);
      setUser(data);
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("userRole", data.role);
      setUserRole(data.role); // pass role to api
      setError(null);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    setUserRole(null);
    localStorage.removeItem("user");
    localStorage.removeItem("userRole");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
